import { Main } from '../components/main/Main';

export const MainPage = () => {
    return (
        <div className="antialiased w-full h-full">
            <div className="w-full min-h-screenbg bg-primary-black">
                <Main />
            </div>
        </div>
    );
};
